module.exports = __webpack_public_path__ + "static/media/alien-monster.48647a7e.svg";